import { HSatzOverviewQueryVariables } from "../types/graphql.types";
import client from "./index";

export const useHSatz = () => {
  return {
    fetchAll: async (variables: HSatzOverviewQueryVariables) => {
      const { findHSaetze } = await client.HSatzOverview(variables);

      return {
        result: findHSaetze,
      };
    },
  };
};
